const IS_UK = window.currentLanguage === 'uk';

export default {
  wall: [{ color: '#fff', base: 0, height: 2.6 }],
  window: [
    { color: '#fff', base: 0, height: 0.5 },
    { color: '#fff', base: 2, height: 2.6 },
  ],
  door: [
    { color: '#fff', base: 0, height: 0 },
    { color: '#fff', base: 2, height: 2.6 },
  ],
  room: [
    {
      color: '#FFCB92',
      base: 0,
      height: 0,
      title: IS_UK ? 'Кімната' : 'Комната',
    },
  ],
  kitchen: [
    {
      color: '#FFAE66',
      base: 0,
      height: 0,
      title: 'Кухня',
    },
  ],
  balcony: [
    {
      color: '#FFE0B0',
      base: 0,
      height: 0,
      title: 'Балкон',
    },
  ],
  bath: [
    {
      color: '#CCF3FF',
      base: 0,
      height: 0,
      title: IS_UK ? 'Санвузол' : 'Санузел',
    },
  ],
  hallway: [
    {
      color: '#FFEBC8',
      base: 0,
      height: 0,
      title: 'Коридор',
    },
  ],
  wardrobe: [
    {
      color: '#FCB675',
      base: 0,
      height: 0,
      title: 'Гардероб',
    },
  ],
  flat: [
    {
      color: '#F06400',
      base: 0,
      height: 0,
    },
  ],
  loggia: [
    {
      color: '#FFE0B0',
      base: 0,
      height: 0,
      title: IS_UK ? 'Лоджія' : 'Лоджия',
    },
  ],
  terrace: [
    {
      color: '#FFE0B0',
      base: 0,
      height: 0,
      title: IS_UK ? 'Тераса' : 'Терраса',
    },
  ],
};
